export enum TagModeEnum {
  default = "",
  News = "Tin tức",
  Image = "Image",
  Video = "Video",
}

export enum ZoneStatusEnum {
  Active = 1,
  NotActive,
}

export function getZoneStatusTitle(status: number) {
  switch (status) {
    case ZoneStatusEnum.Active:
      return "Hoạt động";
    case ZoneStatusEnum.NotActive:
      return "Không hoạt động";
    default:
      return "";
  }
}

//Loại chuyên mục
export enum ZoneTypeEnum {
  Default = 0,
  Course = 1,
  Blog,
  Guide,
}
export function getZoneTypeTitle(type: number) {
  switch (type) {
    case ZoneTypeEnum.Course:
      return "Khóa học";
    case ZoneTypeEnum.Blog:
      return "Tin tức";
    case ZoneTypeEnum.Guide:
      return "Hướng dẫn";
    default:
      return "-- Chọn loại --";
  }
}

export enum TagTypeEnum {
  Tag = 0,
  Thread = 1,
  Topic = 2,
}

export function getTagTypeTitle(type: number) {
  switch (type) {
    case TagTypeEnum.Tag:
      return "tag";
    case TagTypeEnum.Thread:
      return "dòng sự kiện";
    default:
      return "chủ đề";
  }
}

export enum BannerStatusEnum {
  Actived = 1,
  NotActived = 2,
}

export function getBannerStatusTitle(type: number) {
  switch (type) {
    case BannerStatusEnum.Actived:
      return "Hiển thị";
    case BannerStatusEnum.NotActived:
      return "Không hiển thị";
    default:
      return "";
  }
}

export enum BannerTypeEnum {
  Image = 1,
  Flash = 2,
  Embed = 3,
}

export function getBannerTypeTitle(type: number) {
  switch (type) {
    case BannerTypeEnum.Image:
      return "Banner ảnh";
    case BannerTypeEnum.Flash:
      return "Banner flash";
    case BannerTypeEnum.Embed:
      return "Mã nhúng";
    default:
      return "";
  }
}

export enum ObjectTypeEnum {
  SystemFunction = 0,
  News = 1,
  Tag,
  Topic, //Chủ đề
  Thread, //Dòng sự kiện
}

export function getObjectTypeTitle(type: number) {
  switch (type) {
    case ObjectTypeEnum.SystemFunction:
      return "Chức năng hệ thống";
    case ObjectTypeEnum.News:
      return "Tin tức";
    case ObjectTypeEnum.Tag:
      return "Tag";
    case ObjectTypeEnum.Thread:
      return "Dòng sự kiện";
    case ObjectTypeEnum.Topic:
      return "Chủ đề";
    default:
      return "";
  }
}

export enum IdentityErrorsEnum {
  InvalidUserName = "Tên đăng nhập không hợp lệ",
  DuplicateUserName = "Tên đăng nhập đã tồn tại",
  InvalidEmail = "Email không hợp lệ",
  Video = "Video",
}

export const CategoryType = {
  /// <summary>
  /// Hình thức điều trị (Loại điều trị)
  /// </summary>
  treatmentType: "treatment-type",

  /// <summary>
  /// Nhóm lý do (nhóm bệnh)
  /// </summary>
  diseaseType: "disease-type",

  /// <summary>
  /// Lý do từ chối hồ sơ
  /// </summary>
  resonReject: "reson-reject",

  /// <summary>
  /// Loại hồ sơ
  /// </summary>
  documentType: "document-type",

  /// <summary>
  /// Lấy tên loại
  /// </summary>
  /// <param name="type">Loại</param>
  /// <returns>Tên loại</returns>
  getCategoryTypeTitle(type: string) {
    switch (type) {
      case this.treatmentType:
        return "Hình thức điều trị";
      case this.diseaseType:
        return "Nhóm lý do";
      case this.resonReject:
        return "Lý do từ chối hồ sơ";
      case this.documentType:
        return "Loại giấy tờ";
      default:
        return "";
    }
  },
};

export enum UserTypeEnum {
  Default = 0,
  MedCat = 1,
  Company = 2, //Công ty bảo hiểm
  Facility = 3, //Cơ sở y tế
  Customer = 4,
}

export enum LadingBillTypeEnum {
  MedCatRecive = 1,
  MedCatSend = 2,
}

export enum OriginalDocumentStatusEnum {
  NotSent = 0,
  Sent = 1,
  Received = 2,
}

export function getOriginalDocumentStatus(val: number) {
  switch (val) {
    case OriginalDocumentStatusEnum.Sent:
      return "Đã gửi HS gốc";
    case OriginalDocumentStatusEnum.Received:
      return "Nhận đủ HS gốc";
    default:
      return "---";
  }
}

export enum ContractTypeEnum {
  Default = 0,
  Personal = 1,
  Organization = 2,
  Group = 3,
}
export function getContractTypeTitle(type: number) {
  switch (type) {
    case ContractTypeEnum.Personal:
      return "Cá nhân";
    case ContractTypeEnum.Organization:
      return "Tổ chức";
    case ContractTypeEnum.Group:
      return "Nhóm";
    default:
      return "Tất cả";
  }
}

export enum ContractStatusEnum {
  Default = 0,
  NotActived = 1,
  Actived = 2,
  Expired = 3,
}

export function getContractStatusTitle(status: number) {
  switch (status) {
    case ContractStatusEnum.NotActived:
      return "Chưa kích hoạt";
    case ContractStatusEnum.Actived:
      return "Đã kích hoạt";
    case ContractStatusEnum.Expired:
      return "Hết hiệu lực";
    default:
      return "Tất cả";
  }
}

export function getPriorityBgStatus(val: number) {
    switch (val) {
        case 2:
            return "bg-status-violet";
        case 3:
            return "bg-status-yellow";
        case 4:
            return "bg-status-organe";
        case 5:
            return "bg-status-red";
        default:
            return "bg-status-blue";
    }
}

export enum PaymentRequestDocumentStatus {
  NotPaid = 0,
  Paying = 1,
  Paid = 2,
}

export const ListBank: { name: string; shortName: string }[] = [
    { name: "Ngân hàng TMCP Ngoại thương Việt Nam", shortName: "Vietcombank" },
    { name: "Ngân hàng TMCP Công Thương Việt Nam", shortName: "VietinBank" },
    { name: "Ngân hàng Nông nghiệp và Phát triển Nông thôn Việt Nam", shortName: "Agribank" },
    { name: "Ngân hàng TMCP Đầu tư và Phát triển Việt Nam", shortName: "BIDV" },
    { name: "Ngân hàng TMCP Á Châu", shortName: "ACB" },
    { name: "Ngân hàng TMCP Việt Nam Thịnh Vượng", shortName: "VPBank" },
    { name: "Ngân hàng TMCP Kỹ Thương Việt Nam", shortName: "Techcombank" },
    { name: "Ngân hàng TMCP Quân đội", shortName: "MB Bank" },
    { name: "Ngân hàng TMCP Phát triển TP.HCM", shortName: "HDBank" },
    { name: "Ngân hàng TMCP Tiên Phong", shortName: "TPBank" },
    { name: "Ngân hàng TMCP Sài Gòn Thương Tín", shortName: "Sacombank" },
    { name: "Ngân hàng TMCP Đông Á", shortName: "DongA Bank" },
    { name: "Ngân hàng TMCP Quốc tế Việt Nam", shortName: "VIB" },
    { name: "Ngân hàng TMCP Xuất Nhập khẩu Việt Nam", shortName: "Eximbank" },
    { name: "Ngân hàng TMCP Sài Gòn", shortName: "SCB" },
    { name: "Ngân hàng TMCP Bảo Việt", shortName: "BaoViet Bank" },
    { name: "Ngân hàng TMCP Bắc Á", shortName: "Bac A Bank" },
    { name: "Ngân hàng TMCP Nam Á", shortName: "Nam A Bank" },
    { name: "Ngân hàng TMCP An Bình", shortName: "ABBank" },
    { name: "Ngân hàng TMCP Bưu điện Liên Việt", shortName: "LienVietPostBank" },
    { name: "Ngân hàng TMCP Sài Gòn Công Thương", shortName: "SaigonBank" },
    { name: "Ngân hàng TMCP Việt Á", shortName: "VietABank" },
    { name: "Ngân hàng TMCP Bản Việt", shortName: "Viet Capital Bank" },
    { name: "Ngân hàng TMCP Kiên Long", shortName: "KienlongBank" },
    { name: "Ngân hàng TMCP Đại Chúng Việt Nam", shortName: "PVcomBank" },
    { name: "Ngân hàng Chính sách Xã hội Việt Nam", shortName: "VBSP" },
    { name: "Ngân hàng Hợp tác xã Việt Nam", shortName: "Co-opBank" },
    { name: "HSBC Việt Nam", shortName: "HSBC" },
    { name: "Standard Chartered Việt Nam", shortName: "Standard Chartered" },
    { name: "Shinhan Bank Việt Nam", shortName: "Shinhan Bank" },
    { name: "Citibank Việt Nam", shortName: "Citibank" },
    { name: "ANZ Việt Nam", shortName: "ANZ" },
    { name: "UOB Việt Nam", shortName: "UOB" },
    { name: "Public Bank Việt Nam", shortName: "Public Bank" },
    { name: "Woori Bank Việt Nam", shortName: "Woori Bank" },
    { name: "Hong Leong Bank Việt Nam", shortName: "Hong Leong Bank" }
];

export enum ContractBenefitGroupEnum {
  Other = 0,
  PersonalAccident = 1,
  LifeInsurance = 2,
  InpatientTreatment = 3,
  Maternity = 4,
  OutpatientTreatment = 5,
  DentalCare = 6,
}

export function getContractBenefitGroupTitle(type: number) {
  switch (type) {
    case ContractBenefitGroupEnum.Other:
      return "Nhóm quyền lợi khác";
    case ContractBenefitGroupEnum.PersonalAccident:
      return "Quyền lợi bảo hiểm tai nạn";
    case ContractBenefitGroupEnum.LifeInsurance:
      return "Quyền lợi bảo hiểm sinh mạng";
    case ContractBenefitGroupEnum.InpatientTreatment:
      return "Quyền lợi điều trị nội trú";
    case ContractBenefitGroupEnum.Maternity:
      return "Quyền lợi thai sản";
    case ContractBenefitGroupEnum.OutpatientTreatment:
      return "Quyền lợi điều trị ngoại trú";
    case ContractBenefitGroupEnum.DentalCare:
      return "Quyền lợi chăm sóc răng";
    default:
      return "-- Chọn nhóm quyền lợi --";
  }
}

export const ContractBenefitGroupOptions = [
  { value: ContractBenefitGroupEnum.PersonalAccident, label: "Quyền lợi bảo hiểm tai nạn" },
  { value: ContractBenefitGroupEnum.LifeInsurance, label: "Quyền lợi bảo hiểm sinh mạng" },
  { value: ContractBenefitGroupEnum.InpatientTreatment, label: "Quyền lợi điều trị nội trú" },
  { value: ContractBenefitGroupEnum.Maternity, label: "Quyền lợi thai sản" },
  { value: ContractBenefitGroupEnum.OutpatientTreatment, label: "Quyền lợi điều trị ngoại trú" },
  { value: ContractBenefitGroupEnum.DentalCare, label: "Quyền lợi chăm sóc răng" },
  { value: ContractBenefitGroupEnum.Other, label: "Nhóm quyền lợi khác" }
];

// PID Types - Loại thông tin định danh cá nhân
export enum PidTypeEnum {
  NAME = 0,
  ADDRESS = 1,
  PHONE = 2,
  PERSONAL_IDENTIFICATION_NUMBER = 3,
  HEALTH_INSURANCE_CODE = 4,
  SOCIAL_SECURITY_CODE = 5,
  TAX_CODE = 6,
  PATIENT_CODE = 7,
  ALLOCATION_CODE = 8,
  VISIT_CODE = 9,
  MEDICAL_SUMMARY_CODE = 10,
}

export function getPidTypeTitle(type: number): string {
  switch (type) {
    case PidTypeEnum.NAME: return "Họ và tên";
    case PidTypeEnum.ADDRESS: return "Địa chỉ";
    case PidTypeEnum.PHONE: return "Số điện thoại";
    case PidTypeEnum.PERSONAL_IDENTIFICATION_NUMBER: return "CCCD/CMND";
    case PidTypeEnum.HEALTH_INSURANCE_CODE: return "Số bảo hiểm y tế";
    case PidTypeEnum.SOCIAL_SECURITY_CODE: return "Số bảo hiểm xã hội";
    case PidTypeEnum.TAX_CODE: return "Mã số thuế";
    case PidTypeEnum.PATIENT_CODE: return "Mã bệnh nhân";
    case PidTypeEnum.ALLOCATION_CODE: return "Mã cấp phát";
    case PidTypeEnum.VISIT_CODE: return "Mã lần khám";
    case PidTypeEnum.MEDICAL_SUMMARY_CODE: return "Mã hồ sơ bệnh án";
    default: return "Không xác định";
  }
}

// Màu sắc cho mỗi loại PID (11 màu phân biệt)
export const PidTypeColors: Record<number, { fill: string; stroke: string }> = {
  0: { fill: "rgba(255, 99, 132, 0.3)", stroke: "#ff6384" },   // Hồng - Họ và tên
  1: { fill: "rgba(54, 162, 235, 0.3)", stroke: "#36a2eb" },   // Xanh dương - Địa chỉ
  2: { fill: "rgba(255, 206, 86, 0.3)", stroke: "#ffce56" },   // Vàng - SĐT
  3: { fill: "rgba(75, 192, 192, 0.3)", stroke: "#4bc0c0" },   // Xanh ngọc - CCCD
  4: { fill: "rgba(153, 102, 255, 0.3)", stroke: "#9966ff" },  // Tím - BHYT
  5: { fill: "rgba(255, 159, 64, 0.3)", stroke: "#ff9f40" },   // Cam - BHXH
  6: { fill: "rgba(199, 199, 199, 0.3)", stroke: "#c7c7c7" },  // Xám - MST
  7: { fill: "rgba(83, 102, 255, 0.3)", stroke: "#5366ff" },   // Xanh indigo - Mã BN
  8: { fill: "rgba(255, 99, 255, 0.3)", stroke: "#ff63ff" },   // Hồng tím - Mã cấp phát
  9: { fill: "rgba(99, 255, 132, 0.3)", stroke: "#63ff84" },   // Xanh lá - Mã lần khám
  10: { fill: "rgba(255, 159, 159, 0.3)", stroke: "#ff9f9f" }, // Đỏ nhạt - Mã HSBA
};

export const PidTypeOptions = [
  { value: 0, label: "Họ và tên", color: "#ff6384" },
  { value: 1, label: "Địa chỉ", color: "#36a2eb" },
  { value: 2, label: "Số điện thoại", color: "#ffce56" },
  { value: 3, label: "CCCD/CMND", color: "#4bc0c0" },
  { value: 4, label: "Số bảo hiểm y tế", color: "#9966ff" },
  { value: 5, label: "Số bảo hiểm xã hội", color: "#ff9f40" },
  { value: 6, label: "Mã số thuế", color: "#c7c7c7" },
  { value: 7, label: "Mã bệnh nhân", color: "#5366ff" },
  { value: 8, label: "Mã cấp phát", color: "#ff63ff" },
  { value: 9, label: "Mã lần khám", color: "#63ff84" },
  { value: 10, label: "Mã hồ sơ bệnh án", color: "#ff9f9f" },
];